// --- MODULE 1 DATA ---

const moduleData = {
  id: "module-preprologue",
  title: "Pre-Prologue",
  subtitle: "Jantoonam Nara Janma Durlabham (Human birth is rarest)",
  cardImage: "/enBanner/preprologue_banner.jpeg",
  pdfPath: "/en/Modules/preprologue.pdf",
  audio: {
    title: "Vedic Chanting - Omkaram",
    audioUrl: "/en/Audio/preprologue.mp3", 
    duration: "3:45"
  },
  video: {
    id: "tLZSe2bfNsI"
  },
  hero: {
    title: "",
    subtitle: "Module ",
    description: "Jantoonam Nara Janma Durlabham (Human birth is rarest)",
    buttonText: "Explore Vedas",
    bgImage: "/enBanner/preprologue_banner.jpeg",
    bgAlt: "Ancient Manuscripts"
  },
  pages: [
    {
      pageId: 'definition',
      title: 'Definition',
      definition: {
        sectionLabel: "Definition",
        title: "What are Vedas?",
        text: "The Veda is the Mother of all the Shastras (Scriptures). The Veda emanated from God Himself as inhalation and exhalation.",
        quote: {
          sanskrit: "Vidam tu anena iti Vedha",
          meaning: "That which reveals and makes clear all knowledge is Veda.",
          origin: "The word “ved” (Veda) originated from the root “Vid,” meaning “to know.”"
        },
        description: "The sacred Veda instructs all that one requires for his spiritual advancement. It instructs one in the means and methods to overcome all sorrows and grief. It instructs one in all the spiritual disciplines which can give unshaken peace.",
        source: "Sathya Sai Vahini-Eternal Truths",
        image: "http://googleusercontent.com/image_collection/image_retrieval/14294274649611398242", 
        imageAlt: "Vedic Text"
      }
    },
    {
      pageId: 'origin',
      title: 'Origin',
      origin: {
        sectionLabel: "Apaurushëya",
        title: "Who composed the Vedas?",
        image: "http://googleusercontent.com/image_collection/image_retrieval/7760216537183730354", 
        imageAlt: "Sage Vyasa",
        cards: [
          {
            title: "Not of Human Origin",
            text: "The Vedas have no identifiable human authors; they are not from human beings (Apaurushëya). They emerged from God Himself and were 'heard' by sages attuned to the voice of the Divine.",
            source: "Sathya Sai Vahini"
          },
          {
            title: "Codified by Vyasa",
            text: "The Vedas, which are limitless and revealed as illuminations of Eternal Truth, were codified and presented in three collections of hymns by the sage Vyasa for the benefit of humanity: Rig, Yajur, and Sama Veda.",
            source: "Sri Sathya Sai Speaks, Vol 19"
          }
        ]
      }
    },
    {
      pageId: 'shruti',
      title: 'Shruti',
      shruti: {
        sectionLabel: "Transmission",
        title: "Why 'Shruti'?",
        text: "The great sages received Veda as a series of sounds and spread it over the world by word of mouth from preceptor to pupil.",
        highlight: "Since it was “heard” and preserved by generations, the Veda is known as Shruti, “that which was heard or listened to.”",
        image: "http://googleusercontent.com/image_collection/image_retrieval/15491737933097787362", 
        imageAlt: "Guru and Disciple"
      },
      limitless: {
        title: "Ananto vai Veda",
        quote: "The Vedas are countless. The aim of every Veda... is to lead man from the animal state through the human into the height of Divine self-realisation.",
        source: "Divine Discourse - 10th October 1974",
        image: "http://googleusercontent.com/image_collection/image_retrieval/11099273574163984185", 
        imageAlt: "Limitless Knowledge"
      }
    },
    {
      pageId: 'structure',
      title: 'Structure',
      structure: {
        title: "Structure of Vedas",
        description: "Each Veda has a Samhitha (collection) made up of Brahmanas, Aranyakas and Upanishads, laying down practices for the four Ashramas (stages) in life.",
        cards: [
          {
            id: "brahmanas",
            title: "Brahmanas",
            desc: "Prose texts dealing with Mantras or ritual formulae. They describe clearly the sacrificial rites and ceremonies.",
            source: "Karma-Kanda"
          },
          {
            id: "aranyakas",
            title: "Aranyakas",
            desc: "Forest Texts intended for guidance of recluses (Vanaprastha). To be pursued and meditated upon silently.",
            source: "Upasana-Kanda"
          },
          {
            id: "upanishads",
            title: "Upanishads",
            desc: "The philosophical essence (Vedanta) leading to self-knowledge. Literally means 'to sit down near the Guru'.",
            source: "Jnana-Kanda"
          }
        ]
      }
    },
    {
      pageId: 'purpose',
      title: 'Purpose',
      purpose: {
        essence: {
          label: "The Essence",
          title: "Purpose",
          text: "The essence of all the Vedas and Sastras can be summed up in one sentence: The Atma that resides in all beings and in you is one only.",
          subText: "They serve as essential guides in the pursuit of the four Purusharthas: Dharma, Artha, Kama and Moksha.",
          source: "Sri Sathya Sai Speaks, Vol 19"
        },
        universality: {
          label: "Universality",
          title: "Universal Truths",
          text: "The Vedas are Eternal Truths. Just as Western physicists announced the existence of gravitation, the ancients demonstrated the authenticity of Vedas. They are applicable to all people on earth, not just India.",
          subText: "It is like the force of gravitation present everywhere. The Veda is omnipresent.",
          source: "Sathya Sai Vahini"
        },
        image: "http://googleusercontent.com/image_collection/image_retrieval/11546337208281157826" 
      }
    },
    {
      pageId: 'sound',
      title: 'Sound',
      sound: {
        title: "Sabda Brahman: The Primeval Sound",
        description: "Aum is the sound caused by the vibrations of creation through the Emergent Will of the formless and attributeless Brahman. This sound is referred to as Śabda Brahman.",
        subDescription: "The recital of Om twenty one times purifies and clarifies the twenty components of man, making man the twenty-first entity, ready for the final merger with Reality.",
        bgImage: "http://googleusercontent.com/image_collection/image_retrieval/196449436465663613", 
        bgAlt: "Om Symbol Glow",
        mantraCard: {
          title: "Mantra: Mananath Thrayathe",
          points: [
            { label: "Ma", value: "Manana (reflection, understanding)" },
            { label: "Thra", value: "Saving" }
          ],
          footer: "A mantra means that which can save you if you meditate on it, protecting you from the coils of worldly life."
        },
        svaraCard: {
          title: "Veda Svaras (Intonations)",
          desc: "Svara is the intonation level. It falls under Śikṣā and is the lifeblood of authentic Vedic chanting.",
          list: [
            "Udātta (higher note)",
            "Anudatta (lower note)",
            "Svarita (one mātrā) & Dīrgha Svarita (two mātrā)"
          ]
        }
      }
    },
    {
      pageId: 'preservation',
      title: 'Preservation',
      preservation: {
        sectionLabel: "Recitation Techniques",
        title: "Preserving Purity",
        text: "A fool-proof method to preserve the purity of the word, sound, intonation, pronunciation, accent and sound combination of the Vedas was devised through complex chanting patterns.",
        subTitle: "Vikṛti Pāṭhas",
        techniques: ['Samhita', 'Pada', 'Krama', 'Jata', 'Maala', 'Sikha', 'Rekha', 'Dhwaja', 'Danda', 'Ratha', 'Ghana'],
        footer: "By repeating the words in manifold ways, the correct tally of the words was also kept which naturally ensured the pristine purity of the texts.",
        image: "http://googleusercontent.com/image_collection/image_retrieval/2244222132673053757", 
        imageAlt: "Vedic Ritual"
      }
    },
    {
      pageId: 'relevance',
      title: 'Relevance',
      relevance: {
        title: "Relevance of Vedas in Today's Life",
        content: [
          { 
            q: "Vedas - Introduction (15.1 Urdhva-mulam)", 
            a: "Urdhva-mulam, that which has its roots upwards: Brahman, possessed of the unmanifest form of Maya, is referred to by the word 'upward' because of its subtleness in point of time, of its being the Cause, and also because of its eternity and vastness; and That is the root of this world. The Tree of the World which is such, is urdhva-mulam." 
          },
          { q: "Why should I know about Vedas?", a: "They are like a user manual for living from the creator." },
          { q: "Are they relevant only to Hindu faith?", a: "No. They constitute a vast repository of universal knowledge applicable to all mankind." },
          { q: "How do Vedas help me?", a: "They guide me on how to go through the different phases of life following the dos and don’ts." }
        ]
      }
    },
    {
      pageId: 'quiz',
      title: 'Quiz',
      quiz: {
        questions: [
   
        ]
      }
    },
    {
      pageId: 'feedback',
      title: 'Feedback',
      feedback: {}
    }
  ]
};

export { moduleData };